import styled from "@emotion/styled";
import { Box, Dialog, Typography } from "@mui/material";
export const Container = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    scrollMarginTop: "40px",
    marginBottom: "80px"
}));
export const CertificationsContainer = styled(Box)(() => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
}));
export const Image = styled('img')(() => ({
    width: "100px",
    height: "75px",
    margin: "14px",
    cursor: "pointer"
}));
export const Text = styled(Typography)(() => ({
    fontWeight: "bold",
    fontSize: "26px",
    textAlign: "center",
    margin: "15px",
    color: "#8000a4"
}));

export const StyledDialog = ({ className, ...props }) => (
    <Dialog {...props} classes={{ paper: className }} />
);
export const CertificateDialog = styled(StyledDialog)(({ theme }) => ({
    maxWidth: "100%",
    backgroundColor: "transparent",
    boxShadow: "0px 0px 10px 0px transparent",
    '&.MuiDialog-paper': {
        '&>div': {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "17px",
            [theme.breakpoints.down('sm')]: {
                gap: "3px"
            },
            '&>img': {
                maxHeight: "75vmin",
                maxWidth: "75vmin"
            }
        },
        [theme.breakpoints.down('sm')]: {
            margin: 0
        }
    }
}));

export const ArrowContainer = styled(Box)(() => ({
    backgroundColor: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&>svg": {
        fontSize: "2rem"
    }
}));


